import { render, staticRenderFns } from "./lender-information-block.vue?vue&type=template&id=1f27f8e0"
import script from "./lender-information-block.vue?vue&type=script&lang=js"
export * from "./lender-information-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports